<doc-bill-report [selfDoctor]='1'></doc-bill-report>
